import { Field, Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import * as Yup from "yup";
// images
import { Col, Container, InputGroup, Row, Spinner } from "react-bootstrap";
import menuBg from "../../assets/images/bg/menu/request.svg";
import email from "../../assets/images/icons/email2.svg";
import eye_visible from "../../assets/images/icons/eye_visible.svg";
import eye_Invisible from "../../assets/images/icons/eye_Invisible.svg";
import FooterBottom from "../../components/footerBottom";
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import { loginAction } from "./actions";
import "./style.scss";
import { regex } from "../../utils/regex";
import CustomButton from "../../components/Buttons/CustomButton";
import useReactRefresh from "../../hooks/useReactRefresh";

const cookie = new Cookies();

const validationSchema = Yup.object({
  email: Yup.string()
    .required("email can not be empty")
    .email("email must be a valid email address")
    .matches(regex.email, "email must be a valid email address"),
  password: Yup.string().required("password can not be empty").min(8),
  remember_me: Yup.bool(),
});

function Login() {
  const [pathName, setPathName] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const stopLoader = () => setShowLoader(false);
  const location = useLocation();
  const [initialState, setInitialState] = useState({
    email: "",
    password: "",
    remember_me: false,
  });

  const [state, setState] = useState({
    show_pass: false,
  });
  const [openMenu, setOpenMenu] = useState(false);

  const params = new URLSearchParams(document.location.search.substring(1));
  const membership = params.get("membership");
  const redirectUrl = params.get("redirect_url");

  const dispatch = useDispatch();
  const history = useHistory();
  const stripValue = membership === "membership-popup";

  const couponString = typeof location?.state === "object" ? `${location?.state?.location}${location?.state?.search}` : "";

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const intendedUrl = useSelector((state) => state.insurancereducer.intendedUrl);
  const handleSubmit = (values, actions) => {
    setShowLoader(true);
    const data = {
      email: values.email,
      password: values.password,
      remember_me: values.remember_me,
    };
    if (stripValue) {
      data.type = membership;
    }
    if (redirectUrl) {
      data.redirect_url = encodeURIComponent(redirectUrl) || "";
    }
    if (couponString) {
      data.coupon = couponString;
    }
    dispatch(loginAction(data, stopLoader, actions, history, intendedUrl, pathName));
  };

  const handleRememberMe = useCallback((setValue, field, value) => {
    if (!value) localStorage.setItem("remember_me", true);
    else localStorage.removeItem("remember_me");
    setValue(field, !value);
  }, []);

  useEffect(() => {
    if (cookie.get("user_token")) {
      history.goBack();
    }
    if (sessionStorage.getItem("redirect_to")) {
      setPathName(sessionStorage.getItem("redirect_to"));
    }
    if (localStorage.getItem("remember_me")) {
      setInitialState((prev) => ({ ...prev, remember_me: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const redirectToUrl = (url) => (url ? `?redirect_url=${encodeURIComponent(url)}` : "");

  useReactRefresh();

  return (
    <>
      <Helmet>
        <title>Log In - Clarity Cooperative</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header className="headerStyleWhite" openMenu={handleOpenMenu} logoWhite />
      <div className="loginscreen d-none">
        <Container className="py-3 py-sm-4 py-md-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={6}>
              <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema} enableReinitialize>
                {({ values, handleChange, handleBlur, setFieldValue, touched, errors }) => {
                  return (
                    <Form className="loginForm">
                      <h1 className="text-white">Log In</h1>
                      <p className="text-white">Log In and begin learning. We’re excited to be with you on this journey.</p>
                      <div className="accountCard">
                        <div className="mb-2">
                          <InputGroup>
                            <Field
                              className="form-control"
                              id="email"
                              name="email"
                              // component={FrontendTextInput}
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="E-mail*"
                              icons={email}
                            />
                            <InputGroup.Text>
                              <i className="fa-regular fa-fw fa-envelope" />
                            </InputGroup.Text>
                          </InputGroup>
                          {touched.email && errors.email && <div className="errorMessage">{errors.email}</div>}
                        </div>
                        <div className="mb-2">
                          <InputGroup>
                            <Field
                              className="form-control"
                              id="password"
                              name="password"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder="Password*"
                              icons={!state.show_pass ? eye_visible : eye_Invisible}
                              type={state.show_pass ? "text" : "password"}
                              showPassHandler={() =>
                                setState({
                                  ...state,
                                  show_pass: !state.show_pass,
                                })
                              }
                            />
                            <InputGroup.Text
                              className="cursor-pointer"
                              onClick={() =>
                                setState({
                                  ...state,
                                  show_pass: !state.show_pass,
                                })
                              }
                            >
                              <i className={`fa-regular fa-fw ${state.show_pass ? "fa-eye-slash" : "fa-eye"}`} />
                            </InputGroup.Text>
                          </InputGroup>
                          {touched.password && errors.password && <div className="errorMessage">{errors.password}</div>}
                        </div>
                        <div className="form-check">
                          <Field
                            className="form-check-input"
                            id="remember11"
                            onChange={() => handleRememberMe(setFieldValue, "remember_me", values.remember_me)}
                            type="checkbox"
                            name="remember_me"
                            checked={values.remember_me}
                          />
                          <label htmlFor="remember11" className="form-check-label cursor-pointer">
                            Remember me
                          </label>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between align-items-center">
                        {showLoader ? (
                          <div className="d-inline-flex text-white fw-bolder p-0 align-items-center">
                            <p className="mb-0 fw-bolder me-2">Loading...</p>
                            <Spinner animation="border" size="sm" />
                          </div>
                        ) : (
                          <CustomButton variant="marketing" className="mt-2" type="submit" gradient>
                            Log In Now
                          </CustomButton>
                        )}
                        <Link
                          className="forgotPassword text-white mt-2"
                          to={{
                            pathname: `/signup${redirectToUrl(redirectUrl)}`,
                            state: location?.state,
                          }}
                          aria-label="Not a member yet? Sign Up Here"
                        >
                          Not a member yet? Sign Up Here
                        </Link>
                        <Link className="forgotPassword text-white mt-2" to="/forget-password">
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
      <FooterBottom />
    </>
  );
}
export default withRouter(Login);
